@switch(options.type){
    @case ('AgreeDisagreeQuestion') {
        <div class="pt-3 text-secondary fst-italic">
            {{'poll_creation.customize_choices_agree' | translate}}
        </div>
    }
    @case ('FiveStarsQuestion') {
        <div class="pt-3 text-secondary fst-italic">
            {{'poll_creation.customize_choices_fivestars' | translate}}
        </div>
    }
    @case ('ScaleQuestion') {
        <div class="py-2 row">
            <label class="col-sm-12 col-form-label form-stepper-label" for="">{{'poll_creation.customize_choices' | translate}}</label>
            <div class="col-sm-12">
                <div class="row g-3 align-items-center form-group">
                    <div class="col-3">
                        <label class="form-label" for="positiveOption">{{'poll_creation.customize_choices_positive' | translate}}</label>
                    </div>
                    <div class="col-6">
                        <input  id="positiveOption" type="text" name="positiveOption" class="form-control"
                                [formControl]="positiveOptionCtrl">                    
                    </div>
                    <div class="col-3">
                        @if (!positiveOptionCtrl.valid) {
                            <span class="text-danger form-text ps-2">{{'poll_creation.customize_choices_content_error' | translate}}</span>
                        } 
                    </div>
                </div>
                <div class="row g-3 align-items-center form-group">
                    <div class="col-3">
                        <label class="form-label" for="negativeOption">{{'poll_creation.customize_choices_negative' | translate}}</label>
                    </div>
                    <div class="col-6">
                        <input  id="negativeOption" type="text" name="negativeOption" class="form-control"
                                [formControl]="negativeOptionCtrl">                   
                    </div>
                    <div class="col-3">
                        @if (!negativeOptionCtrl.valid) {
                            <span class="text-danger form-text ps-2">{{'poll_creation.customize_choices_content_error' | translate}}</span>
                        } 
                    </div>
                </div>
            </div>
        </div>
    }
    @case ('ClosedQuestion') {
        <div class="py-2 row">
            <label class="col-sm-3 col-form-label form-stepper-label" for="">{{'poll_creation.customize_choices' | translate}}</label>
            <div class="col-sm-9">
                <form [formGroup]="dynamicForm" class="dynamic-options pt-2 position-relative">
                    <div formArrayName="fields">
                        @for(field of fields.controls; let i = $index; track field) {
                            <div [formGroupName]="i"
                                  #nodeInput>
                                <label>
                                    <input formControlName="value" class="form-control" />
                                </label>
                                @if(fields.controls.length > 2){
                                    <button class="border-0 bg-white" type="button" (click)="removeField(i)">
                                        <i class="fa-regular fa-xmark"></i>
                                    </button>
                                }
                                @if (!field.valid && (field.dirty || field.touched)) {
                                    <span class="text-danger form-text ps-2">{{'poll_creation.customize_choices_content_error' | translate}}</span>
                                } 
                            </div>
                        }
                    </div>
                    <button class="mt-2 add-field-btn" type="button" (click)="addField()">
                        <i class="fa-regular fa-plus"></i>&nbsp;{{'poll_creation.customize_choices_add' | translate}}
                    </button>
                </form>
            </div>
        </div>
        @if(fields.controls.length < 3){
            <div class="alert alert-success d-flex align-items-center mt-5" role="alert">
                <p><i class="far fa-info-circle"></i> {{'poll_creation.customize_choices_number' | translate}}</p>
            </div>
        } 
    }
    @default{
        {{options.type}} not reconized // to do call method to log error
    }
}
